import { cva, type VariantProps } from 'class-variance-authority';
import type { ReactNode } from 'react';

import { cn } from '@platform/ui/lib/utils';

/*
 * A status, stated in words on the tint of its functional colour (docs/10 §4,
 * Table): 22px, 12px text, radius 4. The tone follows the meaning, never the
 * look.
 */
export const badgeVariants = cva('inline-flex h-5.5 items-center gap-1 rounded-badge px-2 text-12 font-medium whitespace-nowrap', {
    variants: {
        tone: {
            neutral: 'bg-neutral-subtle text-muted-foreground',
            accent: 'bg-primary-subtle text-primary-strong',
            success: 'bg-success-subtle text-success-strong',
            warning: 'bg-warning-subtle text-warning-strong',
            danger: 'bg-destructive-subtle text-destructive-strong',
            info: 'bg-info-subtle text-info-strong',
        },
    },
    defaultVariants: {
        tone: 'neutral',
    },
});

export type BadgeTone = NonNullable<VariantProps<typeof badgeVariants>['tone']>;

export function Badge({ tone, className, children }: { tone?: BadgeTone; className?: string; children: ReactNode }) {
    return (
        <span data-slot="badge" className={cn(badgeVariants({ tone }), className)}>
            {children}
        </span>
    );
}
